/**
 * Central list of feature flag names. Align with Angular FeatureFlagsService.
 * Boolean flags appear in tenant feature config and in the feature flags table.
 * Global flags support ternary (true / false / null = inherit) in tenants.
 */

export const BOOLEAN_FEATURE_FLAGS = [
  "smsSending",
  "onlineBooking",
  "themePicker",
  "fileUpload",
  "precalculatedAvailabilities",
  "firstLaunch",
  "shiftSchedule",
  "smartBooking",
  "resourceManagement",
  "supportAssistant",
  "stripePayments",
  "bulkSms",
  "subscriptionTesting",
  "appointmentsV2",
  "testDataGenerator",
  "strictTimeSlots",
  "smsSenderRegistration",
  "appointmentChangeHistory",
  "material3",
] as const;

/** The boolean flags offered on the tenant create and edit forms; the matrix covers all boolean flags. */
export const TENANT_FORM_FEATURE_FLAGS = [
  "smsSending",
  "onlineBooking",
  "themePicker",
  "fileUpload",
  "precalculatedAvailabilities",
  "firstLaunch",
  "shiftSchedule",
  "smartBooking",
  "resourceManagement",
  "supportAssistant",
  "stripePayments",
  "bulkSms",
  "subscriptionTesting",
  "appointmentsV2",
] as const satisfies readonly BooleanFeatureFlagName[];

export const NON_BOOLEAN_FEATURE_FLAGS = ["smsProvider"] as const;

export const GLOBAL_FEATURE_FLAGS = [
  "stripePayments",
  "bulkSms",
  "shiftSchedule",
  "precalculatedAvailabilities",
  "resourceManagement",
  "smartBooking",
  "supportAssistant",
  "appointmentsV2",
  "publicRouterCaptcha",
  "strictTimeSlots",
  "smsSenderRegistration",
  "appointmentChangeHistory",
  "material3",
] as const;

export type BooleanFeatureFlagName = (typeof BOOLEAN_FEATURE_FLAGS)[number];
export type GlobalFeatureFlagName = (typeof GLOBAL_FEATURE_FLAGS)[number];

export function getAllFeatureFlags(): readonly string[] {
  return [...BOOLEAN_FEATURE_FLAGS, ...NON_BOOLEAN_FEATURE_FLAGS];
}

export function isBooleanFlag(flagName: string): boolean {
  return (BOOLEAN_FEATURE_FLAGS as readonly string[]).includes(flagName);
}

export function getFeatureFlagLabel(flagName: string): string {
  return flagName.replace(/([A-Z])/g, " $1").trim();
}
